import styled from 'styled-components'
import sidebarNavigationItemStyles from './sidebarNavigationItemStyles'

const SidebarNavigationItemLink = styled.a`
	${sidebarNavigationItemStyles}
`

export default SidebarNavigationItemLink